import React from "react";
import "./page6Styles.css";
import { motion } from "framer-motion";
import page6Img1 from "../../Assets/1x/Asset 37.png";

function Page6() {
  // detect mobile breakpoint
  //const isMobile = window.innerWidth <= 768;
  const isMobile = true;

  return (
    <div className="page6">
      <div className="page6-block">
        {/* Banner Image: Fades in and slides from the left */}
        <motion.img 
          src={page6Img1}
          className="page6-block-banner"
          alt="Banner"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: isMobile }}
        />
        
        {/* Text Block: Fades in and slides from the right */}
        <motion.div
          className="page6-block-text"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: isMobile }}
        >
          <h1>მისწერე მომავალს, შექმენი ისტორია</h1>
          <p>
            „პალიტრა მედიის“ ოცდამეათე საიუბილეო წელთან
            დაკავშირებით გაზეთ "კვირის პალიტრის“ რედაქციამ
            მოქალაქეების თხოვნა გაითვალისწინა და კიდევ ერთხელ
            მისცა საზოგადოებას შესაძლებლობა, მიეწერათ წერილი
            მათთვის ძვირფასი ადამიანებისთვის მომავალში.
            ადრესატი გზავნილს მიიღებს, ავტორის სურვილისამებრ,
            10 ან 25 წლის შემდეგ.
            „კვირის პალიტრის“ 21 აპრილის, 28 აპრილისა და
            5 მაისის ნომრებში დაგხვდებათ კონვერტი, კიდევ ერთი
            „გზავნილისთვის მომავალში“.
            თქვენი წერილი მოთავსდება საგანგებოდ დამზადებულ
            სკივრში, რომელიც დაილუქება და შეინახება ეროვნული
            არქივის საცავში, როგორც ეს 2000 წელს მოხდა.
          </p>
          <p>
            კონვერტზე, რომელიც გაზეთში დაგხვდებათ, დატანილი იქნება დეტალური ინსტრუქცია. მას შემდეგ, რაც წერილს დაწერთ,  მიბრძანდებით „ბიბლუსის“ შერჩეულ მაღაზიაში და კონვერტს ჩააგდებთ ბრენდირებულ ყუთში.<br></br>
            თბილისსა და რეგიონებში მდებარე „ბიბლუსის“ იმ მაღაზიების მისამართები, სადაც „გზავნილი მომავლისთვის“ ბრენდირებული ყუთები იქნება განთავსებული იხილეთ <a href={'https://kvirispalitra.ge/article/130841-miscere-momavals-2035-an-2050-celshi-shekmeni-istoria-unikaluri-shansi-kviris-palitrisgan/'} target={'_blank'}>აქ</a>.
          </p>
          <h2>
            წერილის მომავალში მიწერას ქართველი ემიგრანტებიც შეძლებენ
          </h2>
          <p>
            დეტალური ინსტრუქცია და ჩამოსატვირთი კონვერტი იხილეთ <a href={'https://kvirispalitra.ge/article/131033-specialurad-kartveli-emigrantebistvis-chamotvirte-konverti-da-miscere-momavals-2035-an-2050-celshi/'} target={'_blank'}>აქ</a>.<br></br>
            წერილების მიღების ბოლო ვადაა 2025 წლის 31 მაისი.
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default Page6;
